import { InstallationInstructionsHeader } from 'app/components/InstallationInstructionsHeader';
import React from 'react';
import styled from 'styled-components';
import MapsInstructionImage from 'app/assets/maps-instruction.png';
import { Button } from 'app/components/Button';
import { InstallationProps } from 'app/pages/InstallationInstructions/InstallationProps';
import { AnalyticsClientContext } from 'app/library/Analytics';
import { SlackbotType } from 'app/pages/InstallationChannelSelector/slice/type';

const MainContent = styled.div`
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.5s ease-in;
  @media (max-width: 768px) {
    padding-bottom: 10%;
    min-height: 550px;
    padding: 1em;
  }
`;

const InstructionImage = styled.img`
  max-width: 455px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 0 2em;
  max-width: 800px;
  text-align: center;
  @media (max-width: 768px) {
    padding-bottom: 10%;
    padding: 0 1em;
  }
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2em;
  margin: 1em 0;
  @media (max-width: 768px) {
    display: block;
  }
`;

const StepContent = styled.div`
  justify-content: center;

  display: flex;
  flex-direction: column;
  align-items: center;
`;
const Step = styled.div`
  position: relative;

  color: gray;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 17px;
`;

const StepDiv = styled.div``;

const Title = styled.div`
  line-height: 1.5em;
  color: rgba(0, 0, 0, 0.6);
  font-weight: 400;
  font-size: 20px;
  text-align: left;
`;

const Circle = styled.div`
  background: #ffffff;
  position: relative;
  width: 32px;
  height: 32px;
  line-height: 1.5em;
  border-radius: 100%;
  color: rgba(0, 0, 0, 0.6);
  text-align: center;
  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Line = styled.div`
  height: 25px;
  width: 2px;
  background-color: rgba(0, 0, 0, 0.25);
  left: 16px;
  position: relative;
  margin: 5px 0;
`;

const ButtonContainer = styled.div`
  text-align: center;
  width: 28%;
  margin-top: 1em;
  @media (max-width: 768px) {
    width: 50%;
  }
`;

const Divider = styled.div`
  height: 1em;
`;

export const SkipText = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  cursor: pointer;
`;

export function MapsInstructions(props: InstallationProps) {
  const analyticsClient = React.useContext(AnalyticsClientContext);
  analyticsClient.setSlackIdentity(undefined, SlackbotType.MAPS);

  const gotoInstallionPage = () => {
    analyticsClient.logEvent({
      eventType: 'Maps onboarding instructions page',
    });
    window.location.href =
      process.env.REACT_APP_MAPS_DISTRIBUTION_URL! +
      (!!props.utm ? `?state=${props.utm}` : '');
  };

  const scheduleOnboardingCall = () => {
    window.open(
      'https://calendly.com/d/hhf-6vk-cz7/airspeed-support-call',
      '_blank',
    );
  };

  return (
    <MainContent>
      <Container>
        <InstallationInstructionsHeader
          headerText="Add Maps 📍️ by Airspeed to your Slack workspace"
          subHeader="We’ll walk you through 3 easy steps to get started with Maps."
        />
      </Container>
      <ContentContainer>
        <InstructionImage src={MapsInstructionImage} />
        <StepContent>
          <StepDiv>
            <Step>
              <StepDiv>
                <Circle>1</Circle>
              </StepDiv>

              <StepDiv>
                <Title>Connect to Slack</Title>
              </StepDiv>
            </Step>
            <Line />
            <Step>
              <StepDiv>
                <Circle>2</Circle>
              </StepDiv>

              <StepDiv>
                <Title>Add the app to a channel</Title>
              </StepDiv>
            </Step>
            <Line />
            <Step>
              <StepDiv>
                <Circle>3</Circle>
              </StepDiv>

              <StepDiv>
                <Title>Add your home office location (optional)</Title>
              </StepDiv>
            </Step>
          </StepDiv>
        </StepContent>
      </ContentContainer>
      <ButtonContainer>
        <Button onClick={gotoInstallionPage}>Let’s get started</Button>
        <Divider />

        <SkipText onClick={scheduleOnboardingCall}>
          Schedule onboarding call
        </SkipText>
      </ButtonContainer>
    </MainContent>
  );
}
